module.exports = __webpack_public_path__ + "static/img/refresh.a0285373.png";